"use client";
import React from "react";
import styled from "styled-components";
import ChatInterface from "./ChatInterface";


function Solutions() {
  const features = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_393_1084)">
            <path d="M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18H5V11.9C5 8.03 8.13 4.9 12 4.9C15.87 4.9 19 8.03 19 11.9V19H11V21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z" fill="#D92128"/>
            <path d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z" fill="#D92128"/>
            <path d="M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z" fill="#D92128"/>
            <path d="M18 11.03C17.52 8.18 15.04 6 12.05 6C9.02003 6 5.76003 8.51 6.02003 12.45C8.49003 11.44 10.35 9.24 10.88 6.56C12.19 9.19 14.88 11 18 11.03Z" fill="#D92128"/>
          </g>
          <defs>
            <clipPath id="clip0_393_1084">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "24/7 Personalized Support",
      description: "Real-time, natural language responses for questions on admissions, financial aid, programs, events, and more."
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_393_1089)">
            <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z" fill="#D92128"/>
          </g>
          <defs>
            <clipPath id="clip0_393_1089">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Smart Form Assistance",
      description: "Guidance through FAFSA, tribal aid, and institutional forms, with automation and backend integration"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_393_1094)">
            <path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill="#D92128"/>
          </g>
          <defs>
            <clipPath id="clip0_393_1094">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Enrollment Intelligence Dashboard",
      description: "Staff can view real-time query trends, follow up on incomplete applications, and intervene proactively"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_393_1099)">
            <path d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H11V18.91C8.17 18.43 6 15.97 6 13H8C8 15.21 9.79 17 12 17C14.21 17 16 15.21 16 13H18C18 15.97 15.83 18.43 13 18.91V21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM14 13C14 14.1 13.1 15 12 15C10.9 15 10 14.1 10 13V9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9V13Z" fill="#D92128"/>
          </g>
          <defs>
            <clipPath id="clip0_393_1099">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Culturally Rooted Design",
      description: "From name to voice and visual style, Ask Raven embodies Muscogee identity."
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_393_1104)">
            <path d="M21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM11 11.09V13.09L14.5 15L18 13.09V11.09L14.5 13L11 11.09ZM14.5 6L9 9L14.5 12L20 9L14.5 6Z" fill="#D92128"/>
          </g>
          <defs>
            <clipPath id="clip0_393_1104">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Continuous Learning",
      description: "Nightly analytics offer insight into student concerns, driving ongoing content and service improvements"
    }
  ];

  return (
    <SolutionsContainer>
      <MainTitle>
        The Solution:<br /> Ask Raven – A Culturally-Aware AI Assistant
      </MainTitle>
      <Description>
        In partnership with Campus Insights, CMN launched Ask Raven, a virtual
        assistant powered by the Campus Insights platform, deployed within just
        two weeks. Ask Raven was custom-built to reflect the values, voice, and
        identity of CMN—while using generative AI to serve student needs 24/7.
      </Description>
      <KeyFeaturesContainer>
        <KeyFeaturesTitle>Key Features</KeyFeaturesTitle>
      </KeyFeaturesContainer>
      <ContentContainer>
        <ChatInterface />
        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </FeaturesGrid>
      </ContentContainer>
    </SolutionsContainer>
  );
}

function FeatureCard({ icon, title, description }) {
  return (
    <CardContainer>
      <CardHeader>
        <IconContainer>{icon}</IconContainer>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardDescription>{description}</CardDescription>
    </CardContainer>
  );
}

const CardContainer = styled.article`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 16px;
  background-color: #fff;
  @media (max-width: 640px) {
    padding: 12px 16px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

const CardTitle = styled.h3`
  color: #1c1b1f;
  letter-spacing: -0.2px;
  font: 700 20px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

const CardDescription = styled.p`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const SolutionsContainer = styled.section`
  width: 100%;
  min-height: 1188px;
  position: relative;
  padding: 80px 160px;
  box-sizing: border-box;
  background-color: #333;
  @media (max-width: 1299px) {
    padding: 60px 40px;
  }
  @media (max-width: 640px) {
    padding: 40px 20px;
  }
`;

const MainTitle = styled.h1`
  color: #fff;
  text-align: center;
  letter-spacing: -0.48px;
  margin: 0 auto 40px auto;
  font: 700 40px/120% Inter,  sans-serif;
  @media (max-width: 991px) {
    width: 100%;
    font-size: 36px;
    margin-bottom: 30px;
  }
  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 130%;
    margin-bottom: 20px;
  }
`;

const Description = styled.p`
  color: #fff;
  text-align: center;
  letter-spacing: -0.08px;
  margin: 0 auto 30px auto;
  font: 400 16px/160% Inter,  sans-serif;
  @media (max-width: 991px) {
    width: 100%;
    font-size: 15px;
    margin-bottom: 50px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
    margin-bottom: 40px;
  }
`;

const KeyFeaturesContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const KeyFeaturesTitle = styled.h2`
  color: #fff;
  text-align: center;
  letter-spacing: -0.32px;
  font: 700 32px/120% Inter,  sans-serif;
  @media (max-width: 991px) {
    font-size: 28px;
  }
  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;
  justify-content: center;
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }
  @media (max-width: 640px) {
    gap: 24px;
  }
`;

const FeaturesGrid = styled.div`
  display: flex;
  width: 579px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  height: 664px;
  @media (max-width: 991px) {
    width: 100%;
    max-width: 579px;
  }
`;

export default Solutions;
